module.exports = __webpack_public_path__ + "img/onyx.2953b2cf.png";